<template>
  <lbs-dialog v-if="PDN.isVisible"
              :title="$t('tools-caption')"
              class="lbs-scope-container"
              @close="PDN_TOGGLE_NAVIGATOR">
    <div slot="body"
         class="lbs-scope-container pdn-ui">

      <div v-if="!PDN.isLoaded">
        <p>
          {{ $t('loading') }}
        </p>
        <b-progress :value="100"
                    class="mb-3"
                    variant="info"
                    animated/>
      </div>

      <b-alert v-if="PDN.isLoaded && !PDN.error && PDN.pins.length === 0"
               variant="info"
               show>
        {{ $t('no-pins') }}
      </b-alert>

      <b-alert v-if="PDN.error"
               variant="danger"
               show>
        {{ PDN.error }}
      </b-alert>

      <b-pagination v-if="PDN.isLoaded && !PDN.error && PDN.pins.length > 0"
                    size="md"
                    align="center"
                    :total-rows="PDN.pins.length"
                    :limit="6"
                    v-model="PDN.selectedIndex"
                    @change="change"
                    :per-page="1"/>
    </div>
    <div slot="footer"
         class="lbs-scope-container">
      <b-button v-if="PDN.error"
                size="sm"
                @click="PDN_LOAD_PINS">
        Reload
      </b-button>
    </div>
  </lbs-dialog>
</template>

<script>
  import { mapActions, mapState } from 'shared/stores/core/helpers';
  import LbsDialog from 'uScope/js/components/vue/lbs-dialog';

  export default {
    name: 'PinDropNavigator',
    i18nOptions: { keyPrefix: 'uScope.extensions.pindrop' },
    components: {LbsDialog},
    computed: mapState('PDN'),
    methods: {
      ...mapActions('PDN_TOGGLE_NAVIGATOR', 'PDN_LOAD_PINS'),
      change (selection) {
        this.$dispatch('PDN_SELECT_PIN', {index: selection - 1});
      }
    }
  };
</script>

<style lang="scss" scoped>
  .pdn-ui {
    min-width: 350px;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/vil/uScope-extensions/PinDropNavigator/PinDropNavigator.vue